module.exports = __webpack_public_path__ + "static/media/付费直播@2x.be3e87b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_172/images/付费直播@2x.png
// module id = 1578
// module chunks = 0